import React from "react";
import ApplicationsPage from "./ApplicationsPage";

const PendingApplications = () => <ApplicationsPage status="pending" />;

export default PendingApplications;
